// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"727":"acaaa7b3","940":"9828d142"}[chunkId] + ".js";
};